/**
 * URL publique du site, sans "/" final. Injectée au build (webpack DefinePlugin) pour que les
 * URL canoniques pointent toujours vers le domaine principal, même si la page est servie
 * depuis un alias (www., IP...).
 */
export const SITE_URL = (process.env.SITE_URL || window.location.origin).replace(/\/$/, '');
